export function isEnter(event) {
  return event.key === 'Enter';
}
export function isArrowDown(event) {
  return event.key === 'ArrowDown';
}
export function isArrowUp(event) {
  return event.key === 'ArrowUp';
}
export function isEsc(event) {
  return event.key === keys.ESCAPE || event.key === keys.ESC;
}
export function isSpace(event) {
  return event.key === keys.SPACE_KEY || event.key === keys.SPACE_CODE;
}
export const keys = {
  ESCAPE: 'Escape',
  ESC: 'Esc',
  SPACE_KEY: ' ',
  SPACE_CODE: 'Space'
};